@if (hasSelections()) {
  <ng-content></ng-content>
}
